import { combineReducers } from "redux";
import authReducer from "./auth.reducer";
import userReducer from "./user.reducer";
import sourceBusinessReducer from "./sourceBusiness.reducer";
import voucherReducer from "./voucher.reducer";
import offeringReducer from "./offering.reducer";
import collectionReducer from "./collection.reducer";
import campaignReducer from "./campaign.reducer";
import dashboardReducer from "./dashboard.reducer";
import reportReducer from "./report.reducer";
import platformReportReducer from "./platformReport.reducer";
import DateDataStorage from "./dateData.reducer";
import reportSummaryReducer from "./reportSummary.reducers";
import reportBrandsReducer from "./reportBrands.reducer";
import campaignFilterReducer from './campaignFilter.reducer'
import collectionNewReducer from './collections.reducer';
import campaignNewReducer from './campaignByID.reducer';
import collectionFilterReducer from "./collectionFilter.reducer";
import voucherBatchReducerV3 from "./voucherBatchReducer";
import dateRangeReducer from "./dateRangeReducer";
import brandsReducer from "./brands.action";
import tagsReducer from "./tag.reducer";
import { categoryReducer } from "./chatbotReducers/categoryReducer";
import { cardReducer } from "./chatbotReducers/cardReducer";
import { countryReducer } from "./chatbotReducers/countryReducer";
import chatBotReducers from './chatbotReducers/offeringsReducers';
import brandidReducers from "./chatbotReducers/brandCheckReducers";
import getImagesReducer from "./chatbotReducers/getImagesReducer";

export default combineReducers({
	authReducer,
	userReducer,
	sourceBusinessReducer,
	voucherReducer,
	offeringReducer,
	dashboardReducer,
	collectionReducer,
	campaignReducer,
	reportReducer,

	//platform report reducers
	platformReportReducer,
	DateDataStorage,
	reportSummaryReducer,
	reportBrandsReducer,

	campaignFilterReducer,
	collectionNewReducer,
	campaignNewReducer,
	collectionFilterReducer,
	voucherBatchReducerV3,
	dateRangeReducer,
	brandsReducer,
	tagsReducer,


	// Chatbot Management Reducers
	categoryReducer,
	cardReducer,
	countryReducer,
	chatBotReducers,
	brandidReducers,
	getImagesReducer
});
